module.exports = __webpack_public_path__ + "media/OceanSound.946a7fcd.mp3";